import { render, staticRenderFns } from "./VideoAnalysis.vue?vue&type=template&id=68a8914d&scoped=true&"
import script from "./VideoAnalysis.vue?vue&type=script&lang=js&"
export * from "./VideoAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./VideoAnalysis.vue?vue&type=style&index=0&id=68a8914d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a8914d",
  null
  
)

export default component.exports